export default __webpack_public_path__ + "static/media/home5.a9d5201a.jpg";